import Loadable from 'react-loadable';
import LoadingBar from "../../cmp/PageLoadingBar";

export default Loadable({
    loader: () => import('./TipaltiIndex'),
    loading: LoadingBar
});
